import { IBrandOrder } from "@faire/web-api/indigofair/data/IBrandOrder";
export var isOrderReplaced = function isOrderReplaced(context) {
  var _brandOrder$brand_ord;
  var brandOrder = context.brandOrder;
  var creationReason = brandOrder === null || brandOrder === void 0 ? void 0 : (_brandOrder$brand_ord = brandOrder.brand_order) === null || _brandOrder$brand_ord === void 0 ? void 0 : _brandOrder$brand_ord.creation_reason;
  return creationReason === IBrandOrder.CreationReason.REPLACE_DAMAGED_OR_MISSING_ITEMS;
};